import { gql } from '@apollo/client'

export const CUSTOMER_CART = gql`
    query CustomerCart {
        customerCart {
            id
        }
    }
`